/** Official */
import React from 'react'
import PropTypes from 'prop-types'
/** Vendor */
import { _ } from '@iskytrip/sdk'
import BaseComponent from '@base/BaseComponent'
/** Custom */
import CSS from './index.module.css'

class GLProductSeckill extends BaseComponent {
	constructor(props) {
		super(props)
		this.timeCount = null // 计时器
		this.time = '' // 计时间隔
		this.state = {
			// 计时间隔字符串
			days: '',
			hours: '',
			minutes: '',
			seconds: '',
		}
	}

	componentDidMount() {
		if (_.isHasValue(this.props.item)) {
			if (this.props.item.secKilling) {
				this.startTimer()
			}
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// console.log('componentDidUpdate', prevProps)
		// console.log('componentDidUpdate', prevState)
		if (prevProps.item !== this.props.item) {
			if (this.props.item.secKilling) {
				this.startTimer()
			}
		}
	}

	componentWillUnmount() {
		clearInterval(this.timeCount)
		this.timeCount = null
	}

	startTimer() {
		const item = this.props.item || {}

		clearInterval(this.timeCount)
		this.timeCount = null
		this.time = ''
		// 开启倒计时
		if (+item.activityEndTime > +item.serverTime) {
			const self = this
			this.time = item.activityEndTime - new Date().getTime()
			if (+item.serverTime > 0) {
				this.time = item.activityEndTime - item.serverTime
			}
			this.handleTimer()
			this.timeCount = setInterval(self.handleTimer.bind(self), 1000)
		}
	}

	handleTimer() {
		this.time = this.time - 1000
		if (this.time < 0) {
			clearInterval(this.timeCount)
			this.timeCount = null
			this.time = ''
			console.log('handleTimer clear')
			this.props.endTimer && this.props.endTimer()
		} else {
			const days = Math.floor(this.time / (1000 * 60 * 60 * 24))
			const hours = this.fix0(Math.floor(this.time / (1000 * 60 * 60)) % 24)
			const minutes = this.fix0(Math.floor((this.time / (1000 * 60)) % 60))
			const seconds = this.fix0(Math.floor((this.time / 1000) % 60))
			this.setState({
				days,
				hours,
				minutes,
				seconds,
			})
			// console.log('handleTimer ', hours, minutes, seconds)
		}
	}

	fix0(num) {
		if (num < 10) {
			return '0' + num
		}
		return num
	}

	render() {
		// secKilling 是否抢购中 1:是 0:否
		const item = this.props.item || {}

		const arr = (item.salePrice || '').split('.')
		if (arr.length >= 2) {
			item.price1 = arr[0]
			item.price2 = arr[1]
		}

		if (item.secKilling) {
			return (
				<div
					className={CSS.seckill1}
					style={{
						backgroundImage: `url(https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/seckill_start.png)`,
					}}
				>
					<div className={CSS.seckill1Inner}>
						<div className={CSS.left}>
							<div className={CSS.leftInner1}>
								<p>{item.unit || '￥'}</p>
								<p>{item.price1 || item.salePrice || ''}.</p>
								<p>{item.price2 || '00'}</p>
								{_.isHasValue(item.originalPrice) &&
								+item.originalPrice >= +item.salePrice ? (
									<p
										style={{
											textDecoration:
												+item.salePrice < +item.originalPrice
													? 'line-through'
													: 'none',
										}}
									>
										{item.unit || '￥'}
										{item.originalPrice || ''}
									</p>
								) : (
									<p></p>
								)}
							</div>
							<div className={CSS.leftInner2}>{item.limitBuy || ''}</div>
						</div>
						<div className={CSS.right}>
							<img
								className={CSS.rightInner1}
								src='https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/seckilling.png'
								alt=''
							/>
							<div className={CSS.rightInner2}>
								<p>距结束{+this.state.days > 0 ? ` ${this.state.days}天` : ''}</p>
								<p>{this.state.hours || ''}</p>
								<p>:</p>
								<p>{this.state.minutes || ''}</p>
								<p>:</p>
								<p>{this.state.seconds || ''}</p>
							</div>
						</div>
					</div>
				</div>
			)
		}

		return (
			<div
				className={CSS.seckill2}
				style={{
					backgroundImage: `url(https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/seckill_end.png)`,
				}}
			>
				<div className={CSS.seckill2Inner}>
					<p>预告价</p>
					<p>{item.unit || '￥'}</p>
					<p>{item.price1 || item.salePrice || ''}.</p>
					<p>{item.price2 || '00'}</p>
					{_.isHasValue(item.originalPrice) ? (
						<p
							style={{
								textDecoration:
									+item.salePrice < +item.originalPrice ? 'line-through' : 'none',
							}}
						>
							{item.unit || '￥'}
							{item.originalPrice || ''}
						</p>
					) : (
						<p></p>
					)}
					<p>{item.preSecKillDesc || ''}</p>
				</div>
			</div>
		)
	}
}

export default GLProductSeckill
